import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import BCStep3 from '../images/BC-Step-3.png';
import { Link } from 'react-router-dom';

const WelcomeMessageSubscribers = ({ user }) => {
    return (
        <div className="panel panel-default welcome-message">
            <div className="panel-heading refpayout">
                <span className="BC-head-ico">
                    <LazyLoadImage src={BCStep3} />
                </span>
                <span>
                    Step 5 - Welcome Message for New Subscribers
                </span>
            </div>
            <div className="panel-body">
                <div className="profile-form-control-wrapper">
                    Setup multiple welcome messages to send to your new subscribers. Click <Link to="/welcome-messages">here</Link> to setup.
                </div>
            </div>
        </div>
    );
};

export default React.memo(WelcomeMessageSubscribers);
